/**
 * @generated SignedSource<<5348679d88409840cbc084cca6cb2abb>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type date_nativeIssueTable_DateInlineEditCell_fieldRef$data = {
  readonly id: string;
  readonly lazyIsEditableInIssueView?: boolean | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"date_issueFieldDateInlineEditFull_DateInlineEditViewWithIsEditable_fragmentRef">;
  readonly " $fragmentType": "date_nativeIssueTable_DateInlineEditCell_fieldRef";
};
export type date_nativeIssueTable_DateInlineEditCell_fieldRef$key = {
  readonly " $data"?: date_nativeIssueTable_DateInlineEditCell_fieldRef$data;
  readonly " $fragmentSpreads": FragmentRefs<"date_nativeIssueTable_DateInlineEditCell_fieldRef">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isInlineEditingEnabled"
    }
  ],
  "kind": "Fragment",
  "name": "date_nativeIssueTable_DateInlineEditCell_fieldRef",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "condition": "isInlineEditingEnabled",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "kind": "ScalarField",
              "name": "lazyIsEditableInIssueView"
            }
          ]
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "date_issueFieldDateInlineEditFull_DateInlineEditViewWithIsEditable_fragmentRef"
    }
  ],
  "type": "JiraDatePickerField"
};

(node as any).hash = "d355ad73c106c22099e54f46482d082c";

export default node;
